import type { EventName } from "@lit/react";
import { Grid as GridElement, type GridEventMap as _GridEventMap, } from "@vaadin/grid/vaadin-grid.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { GridElement, };
export type GridEventMap<T1> = Readonly<{
    onActiveItemChanged: EventName<_GridEventMap<T1>["active-item-changed"]>;
    onCellActivate: EventName<_GridEventMap<T1>["cell-activate"]>;
    onCellFocus: EventName<_GridEventMap<T1>["cell-focus"]>;
    onColumnReorder: EventName<_GridEventMap<T1>["column-reorder"]>;
    onColumnResize: EventName<_GridEventMap<T1>["column-resize"]>;
    onDataProviderChanged: EventName<CustomEvent<unknown>>;
    onExpandedItemsChanged: EventName<_GridEventMap<T1>["expanded-items-changed"]>;
    onGridDragend: EventName<_GridEventMap<T1>["grid-dragend"]>;
    onGridDragstart: EventName<_GridEventMap<T1>["grid-dragstart"]>;
    onGridDrop: EventName<_GridEventMap<T1>["grid-drop"]>;
    onItemToggle: EventName<_GridEventMap<T1>["item-toggle"]>;
    onLoadingChanged: EventName<_GridEventMap<T1>["loading-changed"]>;
    onSelectedItemsChanged: EventName<_GridEventMap<T1>["selected-items-changed"]>;
    onSizeChanged: EventName<CustomEvent<unknown>>;
}>;
const events = { onActiveItemChanged: "active-item-changed", onCellActivate: "cell-activate", onCellFocus: "cell-focus", onColumnReorder: "column-reorder", onColumnResize: "column-resize", onDataProviderChanged: "data-provider-changed", onExpandedItemsChanged: "expanded-items-changed", onGridDragend: "grid-dragend", onGridDragstart: "grid-dragstart", onGridDrop: "grid-drop", onItemToggle: "item-toggle", onLoadingChanged: "loading-changed", onSelectedItemsChanged: "selected-items-changed", onSizeChanged: "size-changed" } as GridEventMap<any>;
export type GridProps<T1> = WebComponentProps<GridElement<T1>, GridEventMap<T1>>;
export const Grid = createComponent({
    elementClass: GridElement, events, react: React, tagName: "vaadin-grid"
}) as <T1>(props: GridProps<T1> & React.RefAttributes<GridElement<T1>>) => React.ReactElement | null;
